import { createSlice } from '@reduxjs/toolkit';
import initialState from './initialState';
import { 
	setViews as setViewsReducer,
	setStyle as setStyleReducer,
} from './reducer';

export const layoutSlice = createSlice({
  name: 'layout',
  initialState: initialState,
  reducers: {
    setViews: setViewsReducer,
    setStyle: setStyleReducer,
  },
});

export const { setViews, setStyle } = layoutSlice.actions;

export const viewsSelector = (state) => state.layout.views;
export const listadoEstilosSelector = (state) => state.layout.estilos;
export const tipoEstiloSelector = (state) => state.layout.tipoEstilo;



export default layoutSlice.reducer;